import baseRoute from '../baseRoute';

export default `${baseRoute}/workRequest` as const;
